import React from 'react';
import Box from '../../../box';
import Paragraph from '../../../paragraph';

const TreeSelectNoResult = ({ children }) => (
  <Box paddingLeft="spacing-2-xs" paddingRight="spacing-2-xs">
    <Paragraph appearance="medium-emphasis">{children}</Paragraph>
  </Box>
);

export default TreeSelectNoResult;
